import { render, staticRenderFns } from "./DriverActivityPage.vue?vue&type=template&id=0fd5cca0&scoped=true"
import script from "./DriverActivityPage.vue?vue&type=script&lang=js"
export * from "./DriverActivityPage.vue?vue&type=script&lang=js"
import style0 from "./DriverActivityPage.vue?vue&type=style&index=0&id=0fd5cca0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd5cca0",
  null
  
)

export default component.exports